"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Checkbox_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Checkbox"));
/**
 * A Checkbox allows a user to select a value from a small set of options.
 */
exports.Checkbox = function (props) {
    return React.createElement(Checkbox_1.default, __assign({}, props, { onChange: function (event, data) { return props.onChange && props.onChange(data.checked); } }));
};
exports.default = exports.Checkbox;
